<template>
<div>

 
        <div class="pfd__options">
            <div class="pfd__options--select">
                <div class="pfd__options--select_capacity">
                    <div class="pfd__options--select_capacity--text"> {{ capacityText }} </div>
                    <volume-variant-v2 :volumes="volumesDetail" legend-name="Volume" :aria-label="legendCurrentVolume" :sfccvolumesdetails="variantDetail" :productid="productIds" />
                </div>
                <div class="pfd__options--select_color" v-if="colorList.length > 0">
                    <div class="pfd__options--select_color--text"> {{ colorText }} </div>
                    <color-variant-v2 a11y-close-panel-text="panelText" a11y-next-panel-text="nextPanelText" a11y-previous-panel-text="previousPanelText" :colors="colorList" legend-name="Shade" itemprop="color" :productid="productIds" :sfcccolorsdetails="colorsDetails" />
                </div>
            </div>
        </div>  
</div>
</div>
</template> 
<script>
import ColorVariantV2 from '@Feature/ColorVariant-V2/code/Scripts/components/color-variant-v2';
import VolumeVariantV2 from '@Feature/VolumeVariant-V2/code/Scripts/components/volume-variant-v2'; 

export default {
    name: 'product-description-variant',
    components: {
        ColorVariantV2,
        VolumeVariantV2
    },
    props: {

        colorText: {
            type: String,
            required: false,
            default: ''
        },
        capacityText: {
            type: String,
            required: false,
            default: ''
        },

        variantDetail: {
            type: Array,
            required: false,
            default: []
        },
        volumesDetail: {
            type: Array,
            required: false,
            default: []
        },
        colorsDetails: {
            type: Array,
            required: false,
            default: []
        },
        productIds: {
            type: Array,
            required: false,
            default: []
        },
        colorList: {
            type: Array,
            required: false,
            default: []
        },
        panelText: {
            type: String,
            required: false,
            default: ''
        },
        previousPanelText: {
            type: String,
            required: false,
            default: ''
        },
        nextPanelText: {
            type: String,
            required: false,
            default: ''
        },

        productId: {
            type: String,
            required: false,
            default: ''
        },
        productEan: {
            type: String,
            required: false,
            default: ''
        },

        getData: {
            type: Array,
            required: false,
            default: []
        },
        
        legendCurrentVolume: {
            type: String,
            required: false,
            default: 'legend-volume current-volume'
        },

    },  
};
</script>

<style lang="scss" src="./product-description.scss"></style>
